export { default } from './FormattedDescription';
